import { gql } from '@apollo/client';

export const UPDATE_CLIENT = gql`
    mutation updateClient($data: ClientInput!, $id: ID!) {
        updateClient(data: $data, id: $id) {
            data {
                id
            }
        }
    }
`;

export const QUERY_PUBLIC_CLIENT_PROJECT = gql`
    query publicClientProject (
        $public_key: ID!
    ) {
        publicClientProject(public_key: $public_key) {
            firstName
            lastName
            avatar {
                id
                url
            }
            color
            birthDate
            bonus
            schoolUrl
            project {
                name
                color
                logo {
                    id
                    url
                }
                cover {
                    id
                    url
                }
                levels
                links
                experiences
            }
            projectData
            messages {
                id
                createdAt
                author {
                    firstName
                    lastName
                    color
                    avatar {
                        id
                        url
                    }
                }
                message
            }
            trainings {
                id
                name
                startDate
                author {
                    firstName
                    lastName
                    color
                    avatar {
                        id
                        url
                    }
                }
            }
        }
    }
`;

// export const QUERY_PUBLIC_CLIENT_PROJECT = gql`
//     query publicClientProject (
//         $public_key: ID!
//     ) {
//         publicClientProject(public_key: $public_key) {
//             data {
//                 id
//             }
//         }
//     }
// `